package com.milta.feature.optimizationquota.domain.usecase

import com.milta.feature.optimizationquota.domain.entity.OptimizationQuota
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class GetMyOptimizationQuotaUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(): Result<OptimizationQuota> = repository.getMyQuota()
}
